import ProductPageLayout from "@/components/ProductPageLayout";
import lasirullaverho from "@/assets/lasirullaverho.png?format=webp&w=800";

const ParvekeAsennus = () => (
  <ProductPageLayout title="Parvekkeiden kaihtimet ja rullaverhot" metaDescription="Parvekkeiden kaihtimien ja rullaverhojen asennus Keski-Uudellamaalla. Ammattitaitoinen asennus." image={lasirullaverho} partner="osio" path="/parveke-asennus" alternatePath="/en/balcony-installation">
    <p className="text-muted-foreground leading-relaxed">
      Parvekkeiden lasituksien kaihtimet ja rullaverhot suojaavat parveketta auringolta ja tuovat yksityisyyttä. 
      Tarjoamme kattavan valikoiman automaattiohjattavia ja käsikäyttöisiä malleja.
    </p>
    <h2 className="font-display text-2xl font-bold mt-8 mb-3">Tuotetyypit</h2>
    <ul className="space-y-2 text-muted-foreground">
      <li>✓ Parvekekaihtimet – käsikäyttöiset ja moottoriohjatut</li>
      <li>✓ Parvekerullaverhot – aurinkosuoja ja yksityisyys</li>
      <li>✓ Parvekelasien ratkaisut</li>
    </ul>
    <h2 className="font-display text-2xl font-bold mt-8 mb-3">Ammattimainen asennus</h2>
    <p className="text-muted-foreground leading-relaxed">
      Kiinnitys vaatii tukevaa rakennetta ja ammattitaitoista työtä. Huolehdimme oikeasta kiinnitystavasta 
      ja varmistamme kestävän lopputuloksen. Palvelemme Hyvinkäällä, Järvenpäässä, Keravalla, Mäntsälässä, Nurmijärvellä, Pornaisissa ja Tuusulassa.
    </p>
    <p className="text-muted-foreground mt-4">
      Tutustu <a href="https://osio.fi" target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 text-foreground">Osion valikoimaan</a>.
    </p>
  </ProductPageLayout>
);

export default ParvekeAsennus;
